import { useEffect, useState } from 'react';
import { IRFP_Context } from '../../../lib/models/interfaces';
import { ICiteBlock } from './chatWithSummaryNew';
import axios from 'axios';
import { PdfScrollViewer } from '../pdfViewer/pdfScrollViewer';
import { KoruLoading } from '../shared/KoruLoading';

interface CiteBlockCardProps {
  citeBlock: ICiteBlock | IRFP_Context;
  pinCiteBlock: (id: string, pinAdd: boolean) => void;
  auth: any;
  pinAdd: boolean;
  view: string;
  goToSpecificPage: (pageNo: number, index: number) => void;
  closeModal: (arg: boolean) => void;
  docIndex?: number;
  showSearchBox?: boolean;
  snippetInfo?: { [key: string]: string[] };
  citeIndex?: number | null;
}

export const ActualContextPage = ({
  citeBlock,
  auth,
  pinCiteBlock,
  pinAdd,
  view,
  goToSpecificPage,
  closeModal,
  docIndex,
  showSearchBox,
  snippetInfo = {},
  citeIndex = null
}: CiteBlockCardProps) => {
  // state
  const [showDoc, setShowDoc] = useState<boolean>(false);
  const [presignedURL, setPreSignedURL] = useState<string>('');

  console.log('cite block', citeBlock);

  // Helper to fetch a PDF from URL and return as base64 string

  const fetchPDFAsBase64 = async (url: string): Promise<string> => {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
    });
  };

  const getImageFromS3 = async (docId: string) => {
    if (!auth) return;
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_KORU_API}/get-presigned-url?type=getDocument`,
        { documentId: docId },
        auth
      );
      const url = res.data.url;
      const base64 = await fetchPDFAsBase64(url);
      setPreSignedURL(base64);
      setShowDoc(true);
    } catch (e) {
      console.log('Error from get Image', e);
      setShowDoc(false);
    }
  };
  useEffect(() => {
    getImageFromS3(citeBlock.Document._id);
  }, []);

  return (
    <div className="max-w-3xl max-h-[80vh] min-h-[80vh]">
      {showDoc ? (
        <PdfScrollViewer
          base64={presignedURL}
          startPage={citeBlock.pageNumber}
        />
      ) : (
        <KoruLoading centerText="Loading Document" />
      )}
    </div>
  );
};
